import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { JoinTransformation } from 'app/model/dataflow/jointransformation';
import { Owned } from 'app/model/base/named';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { DataFlowJoinType } from 'app/model/dataflow/dataflow-jointype';
import { JoinPlainObject } from 'worker/app-workers/shared/plainObjects/join.plainObject';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { MultiInputsTransformConvertor } from './multiInputsTransform.convertor';
import { ConditionExpression, ConditionExpressionType } from 'app/model/dataflow/condition-expression';
import { IResourceContext } from 'shell-models-lib';

export class JoinConvertor extends MultiInputsTransformConvertor {
    private get joinTransform(): JoinTransformation {
        return this.transformation as JoinTransformation;
    }

    private get joinObject(): JoinPlainObject {
        return this.transformObject as JoinPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        this.joinTransform.joinType = this.joinObject.joinType as DataFlowJoinType;

        if (this.joinObject.matchType === 'fuzzy') {
            this.joinTransform.matchType = 'fuzzy';
            this.joinObject.fuzzyCompareExpressions.forEach((condition) => {
                const conditionExpression = Owned.create<ConditionExpression>(
                    ConditionExpression.MODEL,
                    this.joinTransform
                );
                conditionExpression.leftExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                    condition.leftExpression
                );
                conditionExpression.rightExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                    condition.rightExpression
                );
                conditionExpression.conditionType = ConditionExpressionType.EQUALS;
                if (condition.overrideSimilarityThreshold !== 0) {
                    conditionExpression.overrideSimilarityThreshold = condition.overrideSimilarityThreshold;
                }
                this.joinTransform.conditionExpressions.push(conditionExpression);
            });
            if (this.joinObject.configs.has('ignoreSpaces')) {
                this.joinTransform.ignoreSpaces = this.joinObject.configs.get('ignoreSpaces') === 'true';
            }
            if (this.joinObject.configs.has('scoreColumn')) {
                const scoreColumn = this.joinObject.configs.get('scoreColumn');
                this.joinTransform.scoreColumn = scoreColumn.substring(1, scoreColumn.length - 1);
            }
        } else {
            this.joinTransform.matchType = 'exact';
            this.joinTransform.ignoreSpaces = false;
        }

        if (this.joinObject.joinType === 'cross') {
            this.joinTransform.crossExpression = Owned.create<DataFlowExpression>(
                DataFlowExpression.MODEL,
                this.joinTransform
            );
            this.joinTransform.crossExpression.requiredReturnType = BooleanDataFlowType.TYPE;
            this.joinTransform.crossExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                this.joinObject.crossExpression
            );
        }

        super.postConvert();
        return this.transformation;
    }
}
